import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BackNavbar from '../../../../ReusableBlocks/Navbar';
import { HOME_PATH } from '../../../../CentralisedLink';
import SalesImpactAnalytics from './SalesImpactAnalytics';
import { canAccessStandaloneSeImpactAnalytics } from './seImpactAnalyticsAccess';
import '../../../../Styles/LeadershipConsole.css';

const SEActivitiesImpactAnalysisPage = () => {
  const currentUser = useSelector((state) => state.auth?.currentUser);

  if (!canAccessStandaloneSeImpactAnalytics(currentUser)) {
    return <Navigate to={HOME_PATH} replace />;
  }

  return (
    <>
      <BackNavbar />

      <div className="manager-console-background lead-dash-page">
        <section>
          <div className="leadership-console-hero-section">
            <div className="container">
              <div className="learning-hub-micro-certs-her-content">
                <h6 className="learning-hub-micro-certs-her-content-h1">
                  SE Activities & Impact Analysis
                </h6>
              </div>
            </div>
          </div>
        </section>

        <div className="leadership-analytics-container se-activities-standalone-report-container">
          <SalesImpactAnalytics />
        </div>
      </div>
    </>
  );
};

export default SEActivitiesImpactAnalysisPage;
